import React, { FC } from 'react';
import styles from './alertModal.module.scss';
import OrganizationModal from 'shared/components/OrganizationModal';
import COButton from 'shared/components/COButton';
import WarningIcon from 'assets//ColorIcons/PNG/warning_alert.png';

interface AlertModalProps {
  onClose: () => void;
  visible: boolean;
}

enum AlertModalEnum {
  ALERT_TEXT = 'Please save your map changes before moving',
  BUTTON_TEXT = 'Go back',
}

const AlertModal: FC<AlertModalProps> = ({ visible, onClose }) => {
  return (
    <OrganizationModal
      visible={visible}
      onClose={onClose}
      width={400}
      children={
        <div className={styles.alertContainer}>
          <div className={styles.alertIconContainer}>
            <img src={WarningIcon} />
          </div>
          <div className={styles.alertTextContainer}>
            {AlertModalEnum.ALERT_TEXT}
          </div>
          <div className={styles.alertButtonContainer}>
            <COButton
              secondary
              children={AlertModalEnum.BUTTON_TEXT}
              onClick={onClose}
            />
          </div>
        </div>
      }
    />
  );
};

export default AlertModal;
